// Generischer CSV-Export: Array von Objekten -> Download als .csv (Excel-kompatibel).
function escapeCell(value) {
  if (value === null || value === undefined) return '';
  const s = String(value);
  // Felder mit Trennzeichen/Anführungszeichen/Zeilenumbruch quoten
  if (/[";\n\r]/.test(s)) {
    return '"' + s.replace(/"/g, '""') + '"';
  }
  return s;
}

/**
 * @param {string} filename  z. B. "ist-stunden-2026.csv"
 * @param {Array<Object>} rows  Datensätze
 * @param {Array<{key:string,label:string}>} [columns]  optionale Spaltenauswahl/-titel
 */
export function downloadCSV(filename, rows, columns) {
  if (!Array.isArray(rows) || rows.length === 0) return false;
  const cols = columns && columns.length
    ? columns
    : Object.keys(rows[0]).map((k) => ({ key: k, label: k }));

  const sep = ';'; // Semikolon: in DE-Excel Standard-Trennzeichen
  const header = cols.map((c) => escapeCell(c.label)).join(sep);
  const lines = rows.map((row) => cols.map((c) => escapeCell(row[c.key])).join(sep));
  // BOM, damit Excel UTF-8 (Umlaute) korrekt erkennt
  const content = '﻿' + [header, ...lines].join('\r\n');

  const blob = new Blob([content], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
  return true;
}
